import { makeUseQueryHook } from '@graphql/functions'
import { EMPTY_TEXT } from '@graphql/placeholders'
import { GetTextDocument } from '@graphql/queries/GetText.graphql'

export enum TextKey {}

/**
 * Fetches text for the given id.
 */
export const useText = (id: string) => {
    const result = useGetText({ variables: { id } })
    return { ...result, text: result.data.text ?? EMPTY_TEXT }
}

const useGetText = makeUseQueryHook({
    query: GetTextDocument,
})
